import React from "react";
import "../styles/NewsSection.css";

const NewsSection = () => {
  return (
    <div className="news-section">
      <h2>🔥 News</h2>
      <div className="news-list">
        <p>
          <b>Aug 2025: </b>Guiding a large bat tour for the opening of the first
          bat park in Munich!
        </p>
        <p>
          <b>Aug 2025: </b>Joining{" "}
          <a
            href="https://www.delphinschutz.org/projekte/geisternetze/"
            target="_blank"
          >
            GRD
          </a>{" "}
          for a ghost net recovery operation in Rügen.{" "}
          <a href="https://www.youtube.com/watch?v=EeXMOF6MFiA" target="_blank">
            Watch the Video
          </a>{" "}
          👻
        </p>
        <p>
          <b>May 2025: </b>Guided my <b>10th</b> bat tour, this time with almost
          200 participants 🎉
        </p>
        {/* <p>
          <b>Apr 2023: </b>Publication on automatic bat bioacoustics accepted at
          Ecological Informatics.
        </p>
        <p>
          <b>Feb 2023: </b>Won 3rd place of the International Ocean Hackathon
          2022 🌊
        </p> */}
      </div>
    </div>
  );
};

export default NewsSection;
